import { Link } from 'react-router-dom'
import React, { ReactElement, FC } from 'react'
import { Box } from '@material-ui/core'
import { analytics } from 'Modules/Analytics'
import { resources as resourcesAnalytics } from 'Modules/Analytics/trackActionInterface/Academy/resources'

interface ConditionalLink {
  children: ReactElement
  to: string
  condition: boolean
  onClickHandler: () => void
}
// Allows 'Open in new tab' by providing href for viewable resources
export const ConditionalLink: FC<ConditionalLink> = ({
  children,
  to,
  condition,
  onClickHandler,
}: ConditionalLink) =>
  condition && to ? (
    <Link
      to={to}
      style={{ textDecoration: 'none', color: 'unset', width: '100%' }}
      onClick={onClickHandler}
    >
      {children}
    </Link>
  ) : (
    <Box onClick={onClickHandler}>{children}</Box>
  )

export const fireBookmarkEvents = (
  id: string,
  type: string,
  title: string,
  isBookmarked: any
) => {
  if (!isBookmarked) {
    const dispatchResourceBookmarkedEvent = analytics.trackActionCreator(
      resourcesAnalytics.Resource_Bookmarked
    )
    dispatchResourceBookmarkedEvent({
      resourceId: id,
      resourceName: title,
      resourceType: type,
    })
  } else {
    const dispatchResourceUnbookmarkedEvent = analytics.trackActionCreator(
      resourcesAnalytics.Resource_Unbookmarked
    )
    dispatchResourceUnbookmarkedEvent({
      resourceId: id,
      resourceName: title,
      resourceType: type,
    })
  }
}
